import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import NontAuthorized401 from "NontAuthorized401";
import TemplateManager from "./components/TemplateManager";

const EmailTemplate = () => {
  const hasToken = Boolean(localStorage.getItem("Token"));

  if (!hasToken) {
    return <NontAuthorized401 />;
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <TemplateManager
        channel="email"
        badgeText="Email Templates"
        heading="Email Notification Templates"
        description="Make simple email templates your team can save and use later."
        subjectLabel="Email Subject"
        bodyLabel="Email Body"
        bodyPlaceholder="Example: Hello, your booking has been confirmed successfully."
        simpleHelpText="Type template name, email subject, and email message. Then click Save Template."
      />
    </DashboardLayout>
  );
};

export default EmailTemplate;
